import React, { useState, useEffect, useContext, useRef } from "react";
import { AuthContext } from "../App";
import {
  Search,
  X,
  AlertTriangle,
  Package,
  RefreshCw,
  Save,
  Tag,
  Euro,
  Clock,
  Loader,
  Plus,
  Minus,
  Users,
  TrendingDown,
  CheckCircle,
  Calendar,
  Filter,
  Settings,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  Eye,
  Gift,
  ShoppingCart,
  Copy,
  Percent
} from "lucide-react";

const API_URL = process.env.REACT_APP_API_URL;

// Componente del Panel Lateral (sin cambios)
const SidePanel = ({ 
  isOpen, 
  setIsOpen,
  activeTab,
  setActiveTab,
  filtroProducto,
  setFiltroProducto,
  marcaFiltro,
  setMarcaFiltro,
  familiaFiltro,
  setFamiliaFiltro,
  estadoOfertaFiltro,
  setEstadoOfertaFiltro,
  fechaDesdeOfertaFiltro,
  setFechaDesdeOfertaFiltro,
  fechaHastaOfertaFiltro,
  setFechaHastaOfertaFiltro,
  productosSeleccionados,
  setProductosSeleccionados,
  productos,
  handleLimpiarFiltros,
  handleLimpiarSeleccion
}) => {
  
  const marcasUnicas = [...new Set(productos.map(p => p.marca).filter(Boolean))];
  const familiasUnicas = [...new Set(productos.map(p => p.familia).filter(Boolean))];

  return (
    <>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed left-4 top-1/2 transform -translate-y-1/2 z-50 bg-white border border-gray-300 rounded-r-lg p-3 shadow-lg hover:bg-gray-50 transition-all duration-300"
        style={{
          left: isOpen ? '384px' : '4px'
        }}
      >
        {isOpen ? <ChevronLeft size={20} className="text-gray-600" /> : <ChevronRight size={20} className="text-gray-600" />}
      </button>

      <div 
        className="fixed left-0 top-16 bottom-0 bg-white border-r border-gray-200 shadow-lg transition-transform duration-300 z-40 overflow-hidden"
        style={{
          width: '380px',
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)'
        }}
      >
        <div className="h-full flex flex-col">
          
          <div className="p-4 border-b border-gray-200 bg-gradient-to-r from-teal-50 to-green-50">
            <div className="flex items-center justify-between mb-2">
              <h2 className="text-lg font-semibold text-gray-800 flex items-center">
                <Settings size={20} className="mr-2 text-teal-600" />
                Panel de Control
              </h2>
            </div>
            <p className="text-sm text-gray-600">
              Filtros y herramientas para gestión de ofertas
            </p>
          </div>

          <div className="flex-1 overflow-y-auto">
            
            <div className="border-b border-gray-200 bg-white">
              <div className="flex">
                <button
                  onClick={() => setActiveTab('productos')}
                  className={`flex-1 py-3 px-4 text-sm font-medium border-b-2 transition-colors ${
                    activeTab === 'productos'
                      ? 'border-teal-500 text-teal-600 bg-teal-50'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  <Package size={16} className="inline mr-2" />
                  Productos
                </button>
                <button
                  onClick={() => setActiveTab('ofertas')}
                  className={`flex-1 py-3 px-4 text-sm font-medium border-b-2 transition-colors ${
                    activeTab === 'ofertas'
                      ? 'border-teal-500 text-teal-600 bg-teal-50'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  <Gift size={16} className="inline mr-2" />
                  Mis Ofertas
                </button>
              </div>
            </div>

            {activeTab === 'productos' && (
              <div className="border-b-4 border-teal-300 bg-gradient-to-r from-teal-50 to-emerald-50">
                <div className="p-4">
                  
                  <div className="space-y-4">
                    <div>
                      <label className="block text-xs font-medium text-gray-700 mb-2 flex items-center">
                        <Search size={12} className="mr-1 text-gray-500" />
                        Búsqueda
                      </label>
                      <input
                        type="text"
                        className="block w-full px-3 py-2 text-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 rounded-lg shadow-sm transition-colors bg-white"
                        placeholder="Nombre, referencia..."
                        value={filtroProducto}
                        onChange={(e) => setFiltroProducto(e.target.value)}
                      />
                    </div>
                    
                    <div>
                      <label className="block text-xs font-medium text-gray-700 mb-2 flex items-center">
                        <Tag size={12} className="mr-1 text-gray-500" />
                        Marca
                      </label>
                      <div className="relative">
                        <select
                          className="block w-full px-3 py-2 text-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 rounded-lg shadow-sm transition-colors appearance-none bg-white"
                          value={marcaFiltro}
                          onChange={(e) => setMarcaFiltro(e.target.value)}
                        >
                          <option value="">Todas las marcas</option>
                          {marcasUnicas.map((marca) => (
                            <option key={marca} value={marca}>
                              {marca}
                            </option>
                          ))}
                        </select>
                        <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                          <ChevronDown size={14} className="text-gray-500" />
                        </div>
                      </div>
                    </div>
                    
                    <div>
                      <label className="block text-xs font-medium text-gray-700 mb-2 flex items-center">
                        <Package size={12} className="mr-1 text-gray-500" />
                        Familia
                      </label>
                      <div className="relative">
                        <select
                          className="block w-full px-3 py-2 text-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 rounded-lg shadow-sm transition-colors appearance-none bg-white"
                          value={familiaFiltro}
                          onChange={(e) => setFamiliaFiltro(e.target.value)}
                        >
                          <option value="">Todas las familias</option>
                          {familiasUnicas.map((familia) => (
                            <option key={familia} value={familia}>
                              {familia}
                            </option>
                          ))}
                        </select>
                        <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                          <ChevronDown size={14} className="text-gray-500" />
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 gap-2">
                      <button
                        onClick={handleLimpiarFiltros}
                        className="flex items-center justify-center px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400 transition-colors shadow-sm font-medium text-sm"
                      >
                        <RefreshCw size={14} className="mr-2" />
                        Limpiar Filtros
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'ofertas' && (
              <div className="border-b-4 border-orange-300 bg-gradient-to-r from-orange-50 to-amber-50">
                <div className="p-4">
                  
                  <div className="space-y-4">
                    <div>
                      <label className="block text-xs font-medium text-gray-700 mb-2 flex items-center">
                        <CheckCircle size={12} className="mr-1 text-gray-500" />
                        Estado
                      </label>
                      <div className="relative">
                        <select
                          className="block w-full px-3 py-2 text-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 rounded-lg shadow-sm transition-colors appearance-none bg-white"
                          value={estadoOfertaFiltro}
                          onChange={(e) => setEstadoOfertaFiltro(e.target.value)}
                        >
                          <option value="">Todos los estados</option>
                          <option value="pendiente">Pendiente</option>
                          <option value="aprobada_parcial">Aprobada Parcial</option>
                          <option value="aprobada_completa">Aprobada Completa</option>
                          <option value="rechazada">Rechazada</option>
                        </select>
                        <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                          <ChevronDown size={14} className="text-gray-500" />
                        </div>
                      </div>
                    </div>

                    <div className="bg-white rounded-lg p-3 border border-orange-200 shadow-sm">
                      <h4 className="font-medium text-orange-800 mb-3 text-xs flex items-center">
                        <Calendar size={14} className="mr-1" />
                        Rango de Fechas
                      </h4>
                      
                      <div className="space-y-3">
                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1">Fecha desde</label>
                          <input
                            type="date"
                            className="block w-full px-3 py-2 text-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 rounded-lg shadow-sm transition-colors bg-white"
                            value={fechaDesdeOfertaFiltro}
                            onChange={(e) => setFechaDesdeOfertaFiltro(e.target.value)}
                          />
                        </div>
                        
                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1">Fecha hasta</label>
                          <input
                            type="date"
                            className="block w-full px-3 py-2 text-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 rounded-lg shadow-sm transition-colors bg-white"
                            value={fechaHastaOfertaFiltro}
                            onChange={(e) => setFechaHastaOfertaFiltro(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 gap-2">
                      <button
                        onClick={handleLimpiarFiltros}
                        className="flex items-center justify-center px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400 transition-colors shadow-sm font-medium text-sm"
                      >
                        <RefreshCw size={14} className="mr-2" />
                        Limpiar Filtros
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

const GestionOfertas = () => {
  const { user } = useContext(AuthContext);
  const modalRef = useRef(null);

  // Estados para el panel lateral y pestañas
  const [sidePanelOpen, setSidePanelOpen] = useState(true);
  const [activeTab, setActiveTab] = useState('productos');

  // Estados para productos
  const [productos, setProductos] = useState([]);
  const [productosSeleccionados, setProductosSeleccionados] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // Estados para la nueva oferta con descuentos individuales
  const [mostrarNuevaOferta, setMostrarNuevaOferta] = useState(false);
  const [productosDescuentos, setProductosDescuentos] = useState({}); // Objeto {producto_id: porcentaje}
  const [modoDescuento, setModoDescuento] = useState('uniforme'); // 'uniforme' o 'individual'
  const [descuentoUniforme, setDescuentoUniforme] = useState("");
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [comentarios, setComentarios] = useState("");
  const [esOfertaTemporal, setEsOfertaTemporal] = useState(false);
  
  // Estados para ofertas existentes
  const [ofertas, setOfertas] = useState([]);
  const [loadingOfertas, setLoadingOfertas] = useState(false);
  
  // Estados para filtros de productos
  const [filtroProducto, setFiltroProducto] = useState("");
  const [marcaFiltro, setMarcaFiltro] = useState("");
  const [familiaFiltro, setFamiliaFiltro] = useState("");
  const [productosFiltrados, setProductosFiltrados] = useState([]);

  // Estados para filtros de ofertas
  const [estadoOfertaFiltro, setEstadoOfertaFiltro] = useState("");
  const [fechaDesdeOfertaFiltro, setFechaDesdeOfertaFiltro] = useState("");
  const [fechaHastaOfertaFiltro, setFechaHastaOfertaFiltro] = useState("");
  const [ofertasFiltradas, setOfertasFiltradas] = useState([]);

  // Estados para modal de detalles de oferta
  const [ofertaSeleccionada, setOfertaSeleccionada] = useState(null);
  const [mostrarDetallesOferta, setMostrarDetallesOferta] = useState(false);

  const token = localStorage.getItem('token');

  // Cargar productos del proveedor
  useEffect(() => {
    const fetchProductos = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await fetch(`${API_URL}/api/ofertas/mis-productos`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error("Error al obtener los productos");
        }

        const data = await response.json();
        setProductos(data.productos);
        setProductosFiltrados(data.productos);
      } catch (error) {
        console.error("Error:", error);
        setError("No se pudieron cargar los productos. " + error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProductos();
  }, [token]);

  // Cargar ofertas del proveedor
  useEffect(() => {
    const fetchOfertas = async () => {
      try {
        setLoadingOfertas(true);

        const response = await fetch(`${API_URL}/api/ofertas/proveedor`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error("Error al obtener las ofertas");
        }

        const data = await response.json();
        setOfertas(data.ofertas);
        setOfertasFiltradas(data.ofertas);
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setLoadingOfertas(false);
      }
    };

    fetchOfertas();
  }, [token]);

  // Filtrar productos
  useEffect(() => {
    let filtrados = productos;

    if (filtroProducto.trim()) {
      filtrados = filtrados.filter(producto =>
        producto.nombre.toLowerCase().includes(filtroProducto.toLowerCase()) ||
        (producto.ref_proveedor && producto.ref_proveedor.toLowerCase().includes(filtroProducto.toLowerCase())) ||
        (producto.marca && producto.marca.toLowerCase().includes(filtroProducto.toLowerCase())) ||
        (producto.familia && producto.familia.toLowerCase().includes(filtroProducto.toLowerCase()))
      );
    }

    if (marcaFiltro) {
      filtrados = filtrados.filter(producto => producto.marca === marcaFiltro);
    }

    if (familiaFiltro) {
      filtrados = filtrados.filter(producto => producto.familia === familiaFiltro);
    }

    setProductosFiltrados(filtrados);
  }, [filtroProducto, marcaFiltro, familiaFiltro, productos]);

  // Filtrar ofertas
  useEffect(() => {
    let filtradas = ofertas;

    if (estadoOfertaFiltro) {
      filtradas = filtradas.filter(oferta => oferta.estado === estadoOfertaFiltro);
    }

    if (fechaDesdeOfertaFiltro) {
      filtradas = filtradas.filter(oferta => 
        new Date(oferta.fecha_creacion) >= new Date(fechaDesdeOfertaFiltro)
      );
    }

    if (fechaHastaOfertaFiltro) {
      filtradas = filtradas.filter(oferta => 
        new Date(oferta.fecha_creacion) <= new Date(fechaHastaOfertaFiltro)
      );
    }

    setOfertasFiltradas(filtradas);
  }, [estadoOfertaFiltro, fechaDesdeOfertaFiltro, fechaHastaOfertaFiltro, ofertas]);

  // Manejar selección de productos
  const handleToggleProducto = (productoId) => {
    setProductosSeleccionados(prev => {
      const existe = prev.includes(productoId);
      let nuevaSeleccion;
      
      if (existe) {
        nuevaSeleccion = prev.filter(id => id !== productoId);
        // Remover descuento individual si se deselecciona
        setProductosDescuentos(prevDescuentos => {
          const nuevosDescuentos = { ...prevDescuentos };
          delete nuevosDescuentos[productoId];
          return nuevosDescuentos;
        });
      } else {
        nuevaSeleccion = [...prev, productoId];
        // Si está en modo individual, asignar descuento por defecto
        if (modoDescuento === 'individual') {
          setProductosDescuentos(prevDescuentos => ({
            ...prevDescuentos,
            [productoId]: ""
          }));
        }
      }
      
      return nuevaSeleccion;
    });
  };

  const handleSeleccionarTodosProductos = () => {
    if (productosSeleccionados.length === productosFiltrados.length) {
      setProductosSeleccionados([]);
      setProductosDescuentos({});
    } else {
      const nuevaSeleccion = productosFiltrados.map(p => p.id);
      setProductosSeleccionados(nuevaSeleccion);
      
      if (modoDescuento === 'individual') {
        const nuevosDescuentos = {};
        nuevaSeleccion.forEach(id => {
          nuevosDescuentos[id] = "";
        });
        setProductosDescuentos(nuevosDescuentos);
      }
    }
  };

  // Manejar cambio de modo de descuento
  const handleCambiarModoDescuento = (nuevoModo) => {
    setModoDescuento(nuevoModo);
    
    if (nuevoModo === 'individual') {
      // Inicializar descuentos individuales para productos seleccionados
      const nuevosDescuentos = {};
      productosSeleccionados.forEach(id => {
        nuevosDescuentos[id] = descuentoUniforme || "";
      });
      setProductosDescuentos(nuevosDescuentos);
    } else {
      // Limpiar descuentos individuales
      setProductosDescuentos({});
    }
  };

  // Manejar cambio de descuento uniforme
  const handleCambiarDescuentoUniforme = (valor) => {
    setDescuentoUniforme(valor);
    
    if (modoDescuento === 'individual') {
      // Aplicar a todos los productos seleccionados
      const nuevosDescuentos = {};
      productosSeleccionados.forEach(id => {
        nuevosDescuentos[id] = valor;
      });
      setProductosDescuentos(nuevosDescuentos);
    }
  };

  // Manejar cambio de descuento individual
  const handleCambiarDescuentoIndividual = (productoId, valor) => {
    setProductosDescuentos(prev => ({
      ...prev,
      [productoId]: valor
    }));
  };

  const handleLimpiarFiltros = () => {
    if (activeTab === 'productos') {
      setFiltroProducto("");
      setMarcaFiltro("");
      setFamiliaFiltro("");
    } else {
      setEstadoOfertaFiltro("");
      setFechaDesdeOfertaFiltro("");
      setFechaHastaOfertaFiltro("");
    }
  };

  const handleLimpiarSeleccion = () => {
    setProductosSeleccionados([]);
    setProductosDescuentos({});
  };

  const calcularPrecioConDescuento = (precioOriginal, descuento) => {
    if (!descuento || descuento === "") return precioOriginal;
    const factor = (100 - parseFloat(descuento)) / 100;
    return Math.round(precioOriginal * factor * 100) / 100;
  };

  // Crear ofertas con descuentos individuales
  const handleCrearOfertas = async () => {
    try {
      if (productosSeleccionados.length === 0) {
        alert("Debe seleccionar al menos un producto");
        return;
      }

      // Preparar array de productos con descuentos
      let productosDescuentosArray = [];

      if (modoDescuento === 'uniforme') {
        if (!descuentoUniforme || descuentoUniforme <= 0 || descuentoUniforme >= 100) {
          alert("El porcentaje de descuento debe ser entre 0 y 100");
          return;
        }
        
        productosDescuentosArray = productosSeleccionados.map(id => ({
          producto_id: id,
          porcentaje_descuento: parseFloat(descuentoUniforme)
        }));
      } else {
        // Validar descuentos individuales
        for (const productoId of productosSeleccionados) {
          const descuento = productosDescuentos[productoId];
          if (!descuento || descuento <= 0 || descuento >= 100) {
            const producto = productos.find(p => p.id === productoId);
            alert(`El descuento del producto "${producto?.nombre}" debe ser entre 0 y 100`);
            return;
          }
          
          productosDescuentosArray.push({
            producto_id: productoId,
            porcentaje_descuento: parseFloat(descuento)
          });
        }
      }

      if (esOfertaTemporal && (!fechaInicio || !fechaFin)) {
        alert("Para ofertas temporales debe especificar fecha de inicio y fin");
        return;
      }

      if (esOfertaTemporal && new Date(fechaInicio) >= new Date(fechaFin)) {
        alert("La fecha de inicio debe ser anterior a la fecha de fin");
        return;
      }

      setLoading(true);

      const response = await fetch(`${API_URL}/api/ofertas/crear-por-productos`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          productos_descuentos: productosDescuentosArray,
          fecha_inicio: esOfertaTemporal ? fechaInicio : null,
          fecha_fin: esOfertaTemporal ? fechaFin : null,
          comentarios: comentarios
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error al crear las ofertas");
      }

      const result = await response.json();
      alert(result.message);
      
      // Resetear formulario
      setMostrarNuevaOferta(false);
      setProductosSeleccionados([]);
      setProductosDescuentos({});
      setModoDescuento('uniforme');
      setDescuentoUniforme("");
      setFechaInicio("");
      setFechaFin("");
      setComentarios("");
      setEsOfertaTemporal(false);

      // Recargar ofertas
      const responseOfertas = await fetch(`${API_URL}/api/ofertas/proveedor`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (responseOfertas.ok) {
        const dataOfertas = await responseOfertas.json();
        setOfertas(dataOfertas.ofertas);
        setOfertasFiltradas(dataOfertas.ofertas);
      }

    } catch (error) {
      console.error("Error:", error);
      alert("Error al crear las ofertas: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  // Ver detalles de oferta
  const handleVerDetallesOferta = (oferta) => {
    setOfertaSeleccionada(oferta);
    setMostrarDetallesOferta(true);
  };

  // Obtener clase CSS para el estado
  const getEstadoClass = (estado) => {
    switch (estado) {
      case 'pendiente':
        return "bg-yellow-100 text-yellow-800";
      case 'aprobada_parcial':
        return "bg-blue-100 text-blue-800";
      case 'aprobada_completa':
        return "bg-green-100 text-green-800";
      case 'rechazada':
        return "bg-red-100 text-red-800";
      case 'rollback':
        return "bg-orange-100 text-orange-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("es-ES");
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("es-ES", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  if (loading && productos.length === 0) {
    return (
      <div className="fixed inset-0 top-16 bg-gradient-to-br from-gray-50 to-gray-100 flex justify-center items-center">
        <div className="text-center">
          <div className="relative mb-8">
            <div className="w-20 h-20 border-4 rounded-full animate-spin border-t-teal-600 mx-auto" style={{borderColor: '#14b8a640', borderTopColor: '#14b8a6'}}></div>
            <Gift className="w-8 h-8 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-teal-500" />
          </div>
          <h3 className="text-xl font-bold mb-2 text-teal-600">Cargando sistema de ofertas</h3>
          <p className="text-gray-600">Obteniendo productos del catálogo...</p>
        </div>
      </div>
    );
  }

  if (error && productos.length === 0) {
    return (
      <div className="fixed inset-0 top-16 bg-gradient-to-br from-gray-50 to-gray-100 flex justify-center items-center">
        <div className="bg-red-100 text-red-800 p-6 rounded-xl shadow-lg max-w-lg w-full border border-red-200 mx-4">
          <div className="flex items-start">
            <AlertTriangle size={28} className="text-red-500 mr-4 flex-shrink-0 mt-1" />
            <div>
              <h3 className="font-bold text-lg text-red-700 mb-2">Error de carga</h3>
              <p className="text-red-700">{error}</p>
              <button 
                onClick={() => window.location.reload()}
                className="mt-4 bg-red-600 hover:bg-red-700 text-white py-2 px-4 rounded-md transition-all duration-200 inline-flex items-center"
              >
                <RefreshCw size={16} className="mr-2" />
                Reintentar
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 top-16 bg-gradient-to-br from-gray-50 to-gray-100 overflow-hidden">
      
      {/* Panel Lateral */}
      <SidePanel
        isOpen={sidePanelOpen}
        setIsOpen={setSidePanelOpen}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        filtroProducto={filtroProducto}
        setFiltroProducto={setFiltroProducto}
        marcaFiltro={marcaFiltro}
        setMarcaFiltro={setMarcaFiltro}
        familiaFiltro={familiaFiltro}
        setFamiliaFiltro={setFamiliaFiltro}
        estadoOfertaFiltro={estadoOfertaFiltro}
        setEstadoOfertaFiltro={setEstadoOfertaFiltro}
        fechaDesdeOfertaFiltro={fechaDesdeOfertaFiltro}
        setFechaDesdeOfertaFiltro={setFechaDesdeOfertaFiltro}
        fechaHastaOfertaFiltro={fechaHastaOfertaFiltro}
        setFechaHastaOfertaFiltro={setFechaHastaOfertaFiltro}
        productosSeleccionados={productosSeleccionados}
        setProductosSeleccionados={setProductosSeleccionados}
        productos={productos}
        handleLimpiarFiltros={handleLimpiarFiltros}
        handleLimpiarSeleccion={handleLimpiarSeleccion}
      />

      {/* Área Principal */}
      <div className="h-full flex flex-col" style={{ 
        marginLeft: sidePanelOpen ? '380px' : '0px',
        transition: 'margin-left 0.3s ease-in-out'
      }}>
        
        {/* Header */}
        <div className="flex-shrink-0 bg-white shadow-sm border-b border-gray-200 p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div className="p-2 rounded-lg mr-3" style={{ backgroundColor: 'rgba(20, 184, 166, 0.1)' }}>
                <Gift size={20} style={{ color: '#14b8a6' }} />
              </div>
              <div>
                <h1 className="text-lg font-bold text-gray-800">Gestión de Ofertas</h1>
                <p className="text-sm text-gray-600">
                  {activeTab === 'productos' 
                    ? `${productos.length} productos en catálogo`
                    : `${ofertas.length} ofertas creadas`
                  }
                </p>
              </div>
            </div>
            
            <div className="flex items-center space-x-2">
              {activeTab === 'productos' && productosSeleccionados.length > 0 && (
                <div className="text-right mr-4">
                  <div className="text-sm font-medium text-gray-900">
                    {productosSeleccionados.length} productos seleccionados
                  </div>
                </div>
              )}
              {activeTab === 'productos' && (
                <button
                  onClick={() => setMostrarNuevaOferta(true)}
                  disabled={productosSeleccionados.length === 0}
                  className={`px-4 py-2 rounded-lg inline-flex items-center transition-colors shadow-sm font-medium ${
                    productosSeleccionados.length === 0
                      ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                      : 'bg-teal-500 hover:bg-teal-600 text-white'
                  }`}
                >
                  <Gift size={16} className="mr-2" />
                  Crear Oferta
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Contenido Principal */}
        <div className="flex-1 overflow-auto">
          <div className="container mx-auto p-6 max-w-7xl">

            {/* Contenido de Productos */}
            {activeTab === 'productos' && (
              <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100">
                <div className="bg-teal-500 p-4">
                  <div className="flex items-center justify-between">
                    <div>
                      <h2 className="text-lg font-bold text-white flex items-center">
                        <Package size={20} className="mr-2" />
                        Catálogo de Productos
                      </h2>
                      <p className="text-white text-sm opacity-90">Selecciona productos para crear ofertas con descuentos personalizados</p>
                    </div>
                    
                    {productosFiltrados.length > 0 && (
                      <button
                        onClick={handleSeleccionarTodosProductos}
                        className="bg-teal-400 hover:bg-teal-600 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors"
                      >
                        {productosSeleccionados.length === productosFiltrados.length ? 'Deseleccionar Todos' : 'Seleccionar Todos'}
                      </button>
                    )}
                  </div>
                </div>

                <div className="p-4">
                  {productosFiltrados.length > 0 ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      {productosFiltrados.map((producto) => (
                        <div
                          key={producto.id}
                          className={`p-4 rounded-lg border-2 transition-all duration-200 cursor-pointer ${
                            productosSeleccionados.includes(producto.id)
                              ? 'border-teal-500 bg-teal-50 shadow-md'
                              : 'border-gray-200 bg-white hover:border-gray-300 hover:shadow-sm'
                          }`}
                          onClick={() => handleToggleProducto(producto.id)}
                        >
                          <div className="flex items-start justify-between mb-3">
                            <div className="flex items-center">
                              <input
                                type="checkbox"
                                checked={productosSeleccionados.includes(producto.id)}
                                onChange={() => handleToggleProducto(producto.id)}
                                className="h-4 w-4 text-teal-600 accent-teal-600 mr-3"
                                onClick={(e) => e.stopPropagation()}
                              />
                              <div className="flex-1">
                                <h3 className="font-semibold text-gray-900 text-sm mb-1">{producto.nombre}</h3>
                              </div>
                            </div>
                          </div>
                          
                          <div className="space-y-2 text-xs text-gray-600">
                            <div><strong>Ref:</strong> {producto.ref_proveedor || 'N/A'}</div>
                            <div><strong>Marca:</strong> {producto.marca || 'N/A'}</div>
                            <div><strong>Familia:</strong> {producto.familia || 'N/A'}</div>
                          </div>

                          <div className="mt-3 pt-3 border-t border-gray-200">
                            <div className="flex items-center justify-between">
                              <div className="text-sm">
                                <div className="flex items-center text-gray-600">
                                  <Users size={14} className="mr-1" />
                                  <span>{producto.total_clientes} clientes</span>
                                </div>
                                {producto.precio_promedio && (
                                  <div className="text-xs text-gray-500 mt-1">
                                    Precio promedio: {formatCurrency(producto.precio_promedio)}
                                  </div>
                                )}
                              </div>
                              {producto.rango_precios && (
                                <div className="text-xs text-right text-gray-500">
                                  <div>Min: {formatCurrency(producto.precio_minimo)}</div>
                                  <div>Max: {formatCurrency(producto.precio_maximo)}</div>
                                </div>
                              )}
                            </div>
                            <div className="mt-2 text-xs text-gray-500">
                              <div className="font-medium mb-1">Clientes:</div>
                              <div className="max-h-16 overflow-y-auto">
                                {producto.clientes_nombres}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-12">
                      <Package size={48} className="mx-auto text-gray-300 mb-4" />
                      <h3 className="text-lg font-medium text-gray-900 mb-2">
                        {filtroProducto || marcaFiltro || familiaFiltro ? 'No se encontraron productos' : 'No hay productos disponibles'}
                      </h3>
                      <p className="text-gray-500">
                        {filtroProducto || marcaFiltro || familiaFiltro
                          ? 'Prueba con otros términos de búsqueda'
                          : 'No tienes productos asignados en el sistema'
                        }
                      </p>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Contenido de Ofertas */}
            {activeTab === 'ofertas' && (
              <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100">
                <div className="bg-teal-500 p-4">
                  <h2 className="text-lg font-bold text-white flex items-center">
                    <Gift size={20} className="mr-2" />
                    Mis Ofertas
                  </h2>
                  <p className="text-teal-100 text-sm">Historial de ofertas creadas con descuentos personalizados</p>
                </div>

                <div className="p-4">
                  {loadingOfertas ? (
                    <div className="text-center py-8">
                      <Loader size={24} className="animate-spin mx-auto text-teal-500 mb-2" />
                      <p className="text-gray-600">Cargando ofertas...</p>
                    </div>
                  ) : ofertasFiltradas.length > 0 ? (
                    <div className="space-y-4">
                      {ofertasFiltradas.map((oferta) => (
                        <div key={oferta.id} className="bg-gray-50 rounded-lg p-4 border border-gray-200 hover:shadow-md transition-shadow">
                          <div className="flex items-center justify-between mb-3">
                            <div className="flex items-center space-x-3">
                              <div className="bg-teal-100 p-2 rounded-lg">
                                <Gift size={16} className="text-teal-600" />
                              </div>
                              <div>
                                <h3 className="font-semibold text-gray-900">Oferta #{oferta.id}</h3>
                                <p className="text-sm text-gray-600">
                                  {oferta.total_productos} productos • {oferta.total_clientes} clientes afectados
                                </p>
                              </div>
                            </div>
                            <div className="flex items-center space-x-2">
                              <span className={`px-3 py-1 rounded-full text-xs font-medium ${getEstadoClass(oferta.estado)}`}>
                                {oferta.estado === 'aprobada_parcial' ? 'Aprobada Parcial' :
                                 oferta.estado === 'aprobada_completa' ? 'Aprobada Completa' :
                                 oferta.estado === 'rollback' ? 'Terminada' :
                                 oferta.estado.charAt(0).toUpperCase() + oferta.estado.slice(1)}
                              </span>
                              <button
                                onClick={() => handleVerDetallesOferta(oferta)}
                                className="bg-blue-500 hover:bg-blue-600 text-white p-2 rounded-lg transition-colors"
                              >
                                <Eye size={16} />
                              </button>
                            </div>
                          </div>

                          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                            <div>
                              <span className="text-gray-600">Descuento promedio:</span>
                              <div className="font-bold text-red-600">-{oferta.porcentaje_descuento}%</div>
                            </div>
                            <div>
                              <span className="text-gray-600">Tipo:</span>
                              <div className="font-medium">
                                {oferta.fecha_inicio && oferta.fecha_fin ? 'Temporal' : 'Atemporal'}
                              </div>
                            </div>
                            <div>
                              <span className="text-gray-600">Progreso:</span>
                              <div className="font-medium">
                                {oferta.productos_aprobados}/{oferta.total_productos} aprobados
                              </div>
                            </div>
                            <div>
                              <span className="text-gray-600">Fecha:</span>
                              <div className="font-medium">{formatDate(oferta.fecha_creacion)}</div>
                            </div>
                          </div>

                          {oferta.fecha_inicio && oferta.fecha_fin && (
                            <div className="mt-3 pt-3 border-t border-gray-200">
                              <span className="text-sm text-gray-600">
                                Período: {formatDate(oferta.fecha_inicio)} - {formatDate(oferta.fecha_fin)}
                              </span>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-8">
                      <Gift size={48} className="mx-auto text-gray-300 mb-4" />
                      <h3 className="text-lg font-medium text-gray-900 mb-2">No hay ofertas para mostrar</h3>
                      <p className="text-gray-500">
                        {estadoOfertaFiltro || fechaDesdeOfertaFiltro || fechaHastaOfertaFiltro
                          ? 'Ajusta los filtros para ver más ofertas'
                          : 'Selecciona productos y crea tu primera oferta con descuentos personalizados'
                        }
                      </p>
                    </div>
                  )}
                </div>
              </div>
            )}

          </div>
        </div>
      </div>

      {/* Modal de Nueva Oferta con Descuentos Individuales */}
      {mostrarNuevaOferta && (
        <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-50 px-4">
          <div 
            className="bg-white rounded-xl shadow-2xl w-full max-w-6xl max-h-[90vh] overflow-hidden"
            ref={modalRef}
          >
            <div className="bg-teal-500 p-4">
              <div className="flex justify-between items-center">
                <h3 className="text-lg font-bold text-white">
                  Nueva Oferta con Descuentos Personalizados
                </h3>
                <button
                  onClick={() => setMostrarNuevaOferta(false)}
                  className="text-white hover:bg-teal-600 p-2 rounded-full transition-colors"
                >
                  <X size={20} />
                </button>
              </div>
            </div>

            <div className="p-6 overflow-y-auto max-h-[calc(90vh-80px)]">
              
              {/* Configuración de descuentos */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                
                {/* Modo de descuento */}
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-3">
                    <Percent size={16} className="inline mr-2" />
                    Tipo de Descuento
                  </label>
                  <div className="flex items-center space-x-6">
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="modoDescuento"
                        checked={modoDescuento === 'uniforme'}
                        onChange={() => handleCambiarModoDescuento('uniforme')}
                        className="h-4 w-4 text-teal-600 accent-teal-600"
                      />
                      <span className="ml-2 text-sm">Descuento uniforme para todos los productos</span>
                    </label>
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="modoDescuento"
                        checked={modoDescuento === 'individual'}
                        onChange={() => handleCambiarModoDescuento('individual')}
                        className="h-4 w-4 text-teal-600 accent-teal-600"
                      />
                      <span className="ml-2 text-sm">Descuentos individuales por producto</span>
                    </label>
                  </div>
                </div>

                {/* Descuento uniforme */}
                {modoDescuento === 'uniforme' && (
                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Porcentaje de Descuento Uniforme (%)
                    </label>
                    <div className="flex items-center space-x-4">
                      <input
                        type="number"
                        min="0.01"
                        max="99.99"
                        step="0.01"
                        className="w-48 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                        value={descuentoUniforme}
                        onChange={(e) => handleCambiarDescuentoUniforme(e.target.value)}
                        placeholder="Ej: 15.50"
                      />
                      <span className="text-sm text-gray-600">
                        Se aplicará a todos los {productosSeleccionados.length} productos seleccionados
                      </span>
                    </div>
                  </div>
                )}

                {/* Tipo de oferta temporal */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Tipo de Oferta
                  </label>
                  <div className="flex items-center space-x-4">
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="tipoOferta"
                        checked={!esOfertaTemporal}
                        onChange={() => setEsOfertaTemporal(false)}
                        className="h-4 w-4 text-teal-600 accent-teal-600"
                      />
                      <span className="ml-2 text-sm">Atemporal</span>
                    </label>
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="tipoOferta"
                        checked={esOfertaTemporal}
                        onChange={() => setEsOfertaTemporal(true)}
                        className="h-4 w-4 text-teal-600 accent-teal-600"
                      />
                      <span className="ml-2 text-sm">Temporal</span>
                    </label>
                  </div>
                </div>

                {/* Fechas temporales */}
                {esOfertaTemporal && (
                  <>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Fecha de Inicio
                      </label>
                      <input
                        type="date"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                        value={fechaInicio}
                        onChange={(e) => setFechaInicio(e.target.value)}
                        min={new Date().toISOString().split('T')[0]}
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Fecha de Fin
                      </label>
                      <input
                        type="date"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                        value={fechaFin}
                        onChange={(e) => setFechaFin(e.target.value)}
                        min={fechaInicio || new Date().toISOString().split('T')[0]}
                      />
                    </div>
                  </>
                )}
              </div>

              {/* Comentarios */}
              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Comentarios (Opcional)
                </label>
                <textarea
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                  rows="3"
                  placeholder="Comentarios adicionales sobre la oferta..."
                  value={comentarios}
                  onChange={(e) => setComentarios(e.target.value)}
                />
              </div>

              {/* Lista de productos con descuentos */}
              <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-6">
                <div className="flex items-center justify-between mb-4">
                  <h4 className="font-semibold text-gray-800">
                    Productos Seleccionados ({productosSeleccionados.length})
                  </h4>
                  {modoDescuento === 'individual' && descuentoUniforme && (
                    <button
                      onClick={() => handleCambiarDescuentoUniforme(descuentoUniforme)}
                      className="text-sm bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded flex items-center"
                    >
                      <Copy size={14} className="mr-1" />
                      Aplicar {descuentoUniforme}% a todos
                    </button>
                  )}
                </div>
                
                <div className="max-h-64 overflow-y-auto">
                  <div className="space-y-3">
                    {productos.filter(p => productosSeleccionados.includes(p.id)).map(producto => (
                      <div key={producto.id} className="bg-white rounded-lg p-4 border border-gray-200">
                        <div className="flex items-center justify-between">
                          <div className="flex-1">
                            <div className="text-sm font-medium text-gray-900">{producto.nombre}</div>
                            <div className="text-xs text-gray-500">{producto.ref_proveedor || 'Sin ref.'}</div>
                            <div className="text-xs text-gray-600 mt-1">
                              {producto.total_clientes} clientes • Precio promedio: {formatCurrency(producto.precio_promedio || 0)}
                            </div>
                          </div>
                          
                          <div className="flex items-center space-x-3">
                            {modoDescuento === 'individual' && (
                              <div className="flex items-center space-x-2">
                                <input
                                  type="number"
                                  min="0.01"
                                  max="99.99"
                                  step="0.01"
                                  className="w-20 px-2 py-1 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                                  value={productosDescuentos[producto.id] || ""}
                                  onChange={(e) => handleCambiarDescuentoIndividual(producto.id, e.target.value)}
                                  placeholder="%"
                                />
                                <span className="text-sm text-gray-600">%</span>
                              </div>
                            )}
                            
                            <div className="text-right">
                              <div className="text-sm text-gray-700">
                                Descuento: {modoDescuento === 'uniforme' ? descuentoUniforme : productosDescuentos[producto.id] || 0}%
                              </div>
                              {(modoDescuento === 'uniforme' ? descuentoUniforme : productosDescuentos[producto.id]) && producto.precio_promedio && (
                                <div className="text-xs text-green-600">
                                  Nuevo: {formatCurrency(calcularPrecioConDescuento(
                                    producto.precio_promedio, 
                                    modoDescuento === 'uniforme' ? descuentoUniforme : productosDescuentos[producto.id]
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Botones de acción */}
              <div className="flex justify-end space-x-4">
                <button
                  onClick={() => setMostrarNuevaOferta(false)}
                  className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  Cancelar
                </button>
                <button
                  onClick={handleCrearOfertas}
                  disabled={productosSeleccionados.length === 0 || loading || 
                    (modoDescuento === 'uniforme' && !descuentoUniforme) ||
                    (modoDescuento === 'individual' && productosSeleccionados.some(id => !productosDescuentos[id]))
                  }
                  className={`px-6 py-2 rounded-lg transition-colors inline-flex items-center ${
                    productosSeleccionados.length === 0 || loading || 
                    (modoDescuento === 'uniforme' && !descuentoUniforme) ||
                    (modoDescuento === 'individual' && productosSeleccionados.some(id => !productosDescuentos[id]))
                      ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                      : 'bg-teal-500 hover:bg-teal-600 text-white'
                  }`}
                >
                  {loading ? (
                    <>
                      <Loader size={16} className="mr-2 animate-spin" />
                      Creando...
                    </>
                  ) : (
                    <>
                      <Save size={16} className="mr-2" />
                      Crear Oferta
                    </>
                  )}
                </button>
              </div>

            </div>
          </div>
        </div>
      )}

      {/* Modal de Detalles de Oferta (actualizado para mostrar descuentos individuales) */}
      {mostrarDetallesOferta && ofertaSeleccionada && (
        <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-50 px-4">
          <div 
            className="bg-white rounded-xl shadow-2xl w-full max-w-6xl max-h-[90vh] overflow-hidden"
            ref={modalRef}
          >
            <div className="bg-teal-500 p-4">
              <div className="flex justify-between items-center">
                <h3 className="text-lg font-bold text-white">
                  Detalles de Oferta #{ofertaSeleccionada.id}
                </h3>
                <button
                  onClick={() => setMostrarDetallesOferta(false)}
                  className="text-white hover:bg-teal-600 p-2 rounded-full transition-colors"
                >
                  <X size={20} />
                </button>
              </div>
            </div>

            <div className="p-6 overflow-y-auto max-h-[calc(90vh-80px)]">
              
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
                
                {/* Información general */}
                <div className="space-y-4">
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h4 className="font-semibold text-gray-800 mb-3">Información General</h4>
                    <div className="space-y-2 text-sm">
                      <div><span className="font-medium">ID de Oferta:</span> #{ofertaSeleccionada.id}</div>
                      <div><span className="font-medium">Descuento promedio:</span> <span className="text-red-600 font-bold">-{ofertaSeleccionada.porcentaje_descuento}%</span></div>
                      <div><span className="font-medium">Estado:</span> 
                        <span className={`ml-2 px-2 py-1 rounded text-xs font-medium ${getEstadoClass(ofertaSeleccionada.estado)}`}>
                          {ofertaSeleccionada.estado === 'aprobada_parcial' ? 'Aprobada Parcial' :
                           ofertaSeleccionada.estado === 'aprobada_completa' ? 'Aprobada Completa' :
                           ofertaSeleccionada.estado.charAt(0).toUpperCase() + ofertaSeleccionada.estado.slice(1)}
                        </span>
                      </div>
                      <div><span className="font-medium">Tipo:</span> {ofertaSeleccionada.fecha_inicio && ofertaSeleccionada.fecha_fin ? 'Temporal' : 'Atemporal'}</div>
                      {ofertaSeleccionada.fecha_inicio && ofertaSeleccionada.fecha_fin && (
                        <div><span className="font-medium">Período:</span> {formatDate(ofertaSeleccionada.fecha_inicio)} - {formatDate(ofertaSeleccionada.fecha_fin)}</div>
                      )}
                      <div><span className="font-medium">Creada:</span> {formatDate(ofertaSeleccionada.fecha_creacion)}</div>
                      <div><span className="font-medium">Progreso:</span> {ofertaSeleccionada.productos_aprobados}/{ofertaSeleccionada.total_productos} productos aprobados</div>
                    </div>
                  </div>

                  {ofertaSeleccionada.comentarios && (
                    <div className="bg-gray-50 rounded-lg p-4">
                      <h4 className="font-semibold text-gray-800 mb-3">Comentarios</h4>
                      <p className="text-sm text-gray-700 whitespace-pre-wrap">{ofertaSeleccionada.comentarios}</p>
                    </div>
                  )}
                </div>

                {/* Estadísticas */}
                <div className="space-y-4">
                  <div className="bg-gradient-to-r from-teal-50 to-green-50 rounded-lg p-4 border border-teal-200">
                    <h4 className="font-semibold text-teal-800 mb-3">Estadísticas</h4>
                    <div className="grid grid-cols-2 gap-4">
                      <div className="text-center">
                        <div className="text-2xl font-bold text-teal-600">{ofertaSeleccionada.total_productos}</div>
                        <div className="text-sm text-teal-700">Productos Total</div>
                      </div>
                      <div className="text-center">
                        <div className="text-2xl font-bold text-green-600">{ofertaSeleccionada.productos_aprobados}</div>
                        <div className="text-sm text-green-700">Productos Aprobados</div>
                      </div>
                      <div className="text-center">
                        <div className="text-2xl font-bold text-blue-600">{ofertaSeleccionada.total_clientes}</div>
                        <div className="text-sm text-blue-700">Clientes Afectados</div>
                      </div>
                      <div className="text-center">
                        <div className="text-2xl font-bold text-red-600">-{ofertaSeleccionada.porcentaje_descuento}%</div>
                        <div className="text-sm text-red-700">Descuento Promedio</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Lista de productos con descuentos individuales */}
              <div className="bg-gray-50 rounded-lg p-4">
                <h4 className="font-semibold text-gray-800 mb-3">Productos con Descuentos Individuales</h4>
                <div className="max-h-64 overflow-y-auto">
                  <div className="space-y-3">
                    {ofertaSeleccionada.productos && ofertaSeleccionada.productos.map(producto => {
                      let totalClientes = 0;
                      try {
                        const clientesData = JSON.parse(producto.clientes_datos);
                        totalClientes = Object.keys(clientesData).length;
                      } catch (error) {
                        console.error('Error parsing clientes_datos:', error);
                      }

                      return (
                        <div key={producto.id} className="bg-white rounded-lg p-3 border border-gray-200">
                          <div className="flex items-center justify-between">
                            <div className="flex-1">
                              <div className="font-medium text-gray-900">{producto.producto_nombre}</div>
                              <div className="text-sm text-gray-600">{producto.ref_proveedor || 'Sin ref.'} {producto.marca && `• ${producto.marca}`}</div>
                              <div className="text-xs text-gray-500">{totalClientes} clientes afectados</div>
                            </div>
                            <div className="text-right">
                              <div className="text-lg font-bold text-red-600">-{producto.porcentaje_descuento}%</div>
                              <span className={`px-2 py-1 rounded text-xs font-medium ${getEstadoClass(producto.estado_producto)}`}>
                                {producto.estado_producto === 'pendiente' ? 'Pendiente' :
                                 producto.estado_producto === 'aprobada' ? 'Aprobada' : 'Rechazada'}
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              <div className="flex justify-end mt-6">
                <button
                  onClick={() => setMostrarDetallesOferta(false)}
                  className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  Cerrar
                </button>
              </div>

            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default GestionOfertas;